import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫网站',
    url: 'https://hanman.example.com',
    description: '访问韩漫网站，免费享受韩国漫画，通过韩漫网址便捷导航，浏览韩漫大全合集，满足您对高质量漫画的阅读欲望。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://hanman.example.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫网站',
    url: 'https://hanman.example.com',
    description: '韩漫网站——最全的韩国漫画免费在线阅读平台',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩漫网站是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫网站是一个专业的韩国漫画免费在线阅读平台，提供海量韩国漫画资源。通过韩漫网址，您可以便捷访问韩漫大全合集，包括恋爱、奇幻、动作、悬疑、都市、历史、搞笑、恐怖等八大分类，每日更新，满足您对高质量漫画的阅读需求。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫网站上的漫画可以免费看吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，韩漫网站提供韩国漫画免费在线阅读服务。您可以通过韩漫网址访问平台，免费浏览韩漫大全中的所有漫画作品，无需付费即可享受高质量的漫画阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫大全有哪些类型？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫大全涵盖八大分类：恋爱漫画（青春校园、甜宠治愈）、奇幻漫画（魔法冒险、异世界）、动作漫画（格斗热血、犯罪追踪）、悬疑漫画（推理破案、心理惊悚）、都市漫画（职场商战、豪门恩怨）、历史漫画（朝鲜王朝、武侠传奇）、搞笑漫画（日常喜剧、废柴逆袭）、恐怖漫画（灵异鬼怪、科幻惊悚），满足各类漫画爱好者的需求。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫网站多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫网站保持每日更新频率，确保读者能够第一时间阅读到最新的韩国漫画内容。各分类下的热门作品均定期更新，部分完结作品也可在平台上完整阅读。',
        },
      },
      {
        '@type': 'Question',
        name: '如何通过韩漫网址找到想看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过以下几种方式在韩漫网站上找到想看的漫画：使用顶部的搜索栏直接搜索漫画名称；浏览首页的热门推荐和排行榜；进入分类页面按类型筛选；查看最新更新列表。韩漫网址提供便捷的导航系统，帮助您快速定位感兴趣的漫画作品。',
        },
      },
    ],
  };

  return (
    <>
      <SEO
        title="韩漫网站_韩国漫画免费_韩漫网址_韩漫大全"
        description="访问韩漫网站，免费享受韩国漫画，通过韩漫网址便捷导航，浏览韩漫大全合集，满足您对高质量漫画的阅读欲望。每日更新，海量韩漫资源一网打尽。"
        keywords="韩漫网站,韩国漫画免费,韩漫网址,韩漫大全,韩国漫画,免费漫画,在线漫画,漫画推荐"
        canonicalUrl="https://hanman.example.com/"
      />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <article>
        <HeroSection />

        <section>
          <h1 className="sr-only">韩漫网站 - 韩国漫画免费在线阅读平台</h1>
        </section>

        <HotRecommend />
        <CategorySection />
        <LatestUpdates />
        <RankingSection />

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 text-center">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
              开始你的韩漫之旅
            </h2>
            <p className="text-foreground-600 max-w-xl mx-auto mb-6 text-sm md:text-base">
              韩漫网站汇聚海量韩国漫画免费资源，通过韩漫网址便捷导航，韩漫大全合集一网打尽。立即开始阅读，发现你最爱的那部韩漫！
            </p>
            <a
              href="/category/romance"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
            >
              免费开始阅读
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </section>
      </article>
    </>
  );
}